import React from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">KVKK Aydınlatma Metni</h1>
        <Card>
          <CardContent className="p-8 prose max-w-none">
            <p className="text-sm text-gray-500 mb-6">Son Güncelleme: {new Date().toLocaleDateString('tr-TR')}</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Veri Sorumlusu</h2>
            <p className="text-gray-700 mb-4">AIMERKUR (Admosphere iştiraki) olarak 6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca veri sorumlusuyuz.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. İşlenen Kişisel Veriler</h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Kimlik Bilgileri (Ad, soyad, e-posta)</li>
              <li>İletişim Bilgileri (Telefon, adres)</li>
              <li>Müşteri İşlem Bilgileri (Soru-cevap verileri)</li>
              <li>İşlem Güvenliği Bilgileri (IP adresi, çerez verileri)</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Kişisel Verilerin İşlenme Amacı</h2>
            <p className="text-gray-700 mb-4">Verileriniz hizmet sunumu, müşteri memnuniyeti, faturalama ve yasal yükümlülükler için işlenmektedir.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Veri Güvenliği</h2>
            <p className="text-gray-700 mb-4">Verileriniz şifreli olarak saklanmakta ve güvenlik önlemleri alınmaktadır.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Haklarınız</h2>
            <p className="text-gray-700 mb-4">KVKK Madde 11 kapsamında verilerinize erişim, düzeltme, silme ve itiraz etme haklarınız bulunmaktadır.</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. İletişim</h2>
            <p className="text-gray-700">KVKK talepleri için: kvkk@aimerkur.com</p>
          </CardContent>
        </Card>
      </div>
      <Footer />
    </div>
  );
}
